import { Skeleton } from '@/components/Skeleton';

const HeadingSkeleton = () => (
  <div className="heading">
    <h1 className="title" style={{ width: '60%' }}>
      <Skeleton inline width="100%" />
    </h1>
    <p className="subTitleContainer" style={{ width: '30%' }}>
      <Skeleton inline width="100%" />
    </p>
  </div>
);

export default HeadingSkeleton;
